import React from 'react';
import { Form, FormGroup } from 'reactstrap';
import uniqueId from 'lodash/uniqueId';
import SkeletonElement from '../../../../components/skeletons/SkeletonElement';

const FIELDS_COUNT = 4;

const CheckoutFormSkeleton = () => {
  const fields = [...Array(FIELDS_COUNT)].map(() => (
    <FormGroup className="mb-4" key={uniqueId()}>
      <SkeletonElement type="label-short" className="mb-3" />
      <SkeletonElement type="input" />
    </FormGroup>
  ));

  return (
    <Form className="checkout-form my-4">
      {fields}
      <FormGroup className="mb-4">
        <SkeletonElement type="label-short" className="mb-4" />
        <SkeletonElement type="label" className="mb-3" />
        <SkeletonElement type="label" />
      </FormGroup>
      <FormGroup className="accept-privacy-statement d-flex align-items-start">
        <SkeletonElement type="label" />
      </FormGroup>
      <FormGroup>
        <SkeletonElement type="button" />
      </FormGroup>
    </Form>
  );
};

export default CheckoutFormSkeleton;
